import { createSlice } from '@reduxjs/toolkit';

const rolesSlice = createSlice({
  name: 'roles',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    fetchRolesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRolesSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.lastFetched = Date.now();
    },
    fetchRolesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchRolesStart, fetchRolesSuccess, fetchRolesFailure } = rolesSlice.actions;
export default rolesSlice.reducer;
